import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/content";

const quickLinks = [
  { label: "品牌介绍", path: "/brand" },
  { label: "最新动态", path: "/news" },
  { label: "产品资讯", path: "/products" },
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
];

const socials = [
  { icon: "ri-wechat-line", label: "微信公众号" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-zhihu-line", label: "知乎" },
  { icon: "ri-instagram-line", label: "小红书" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-primary-100 mt-20">
      <div className="max-w-site mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 lg:pr-16">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-accent-950 text-lg font-heading">
                白
              </span>
              <span className="font-heading text-lg font-semibold text-background-50 tracking-wide">
                白峰美羽
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-primary-200 max-w-md">
              {siteInfo.intro}
            </p>
            <div className="flex items-center gap-3 mt-6">
              {socials.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  title={s.label}
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-800 text-primary-100 hover:bg-accent-500 hover:text-accent-950 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-5 font-heading">
              <a href="/#" className="cursor-pointer">快速导航</a>
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-primary-200 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-5 font-heading">联系我们</h4>
            <ul className="space-y-3 text-sm text-primary-200">
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-line mt-0.5 text-accent-400"></i>
                <a href={`tel:${siteInfo.phone}`} className="hover:text-accent-300 transition-colors cursor-pointer">
                  {siteInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <a href={`mailto:${siteInfo.email}`} className="hover:text-accent-300 transition-colors cursor-pointer break-all">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                <span className="leading-relaxed">{siteInfo.address}</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line mt-0.5 text-accent-400"></i>
                <span>{siteInfo.workTime}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© {new Date().getFullYear()} 白峰美羽 BaiFeng MeiYu. 保留所有权利。</p>
          <p className="text-primary-400">本站演示内容均为虚构，仅用于品牌展示。</p>
        </div>
      </div>
    </footer>
  );
}